const IndCategoryMapping = [
  {
    Paycheck: ["Paycheck"],
    USA_Salary: ["USA Salary"],
    Residential_Rent: ["Residential Rent"],
    House_Advance: ["House Advance"],
    GeniusNexa_Income: ["GeniusNexa Income"],
    Renunumari_Income: ["Renunumari Income"],
    Gpay_Cashback: ["Gpay Cashback"],
    Savings_Interest: ["Savings Interest"],
    Dividend_Income: ["Dividend Income"],
    Tax_Refund: ["Tax Refund"],
    Other_Income: ["Other Income"],

    Mutual_Fund: ["Equity Investments", "Mutual Fund"],
    Pension: ["Pension"],

    Stock: [
      "ICICI Direct Transactions Debit",
      "ICICI Direct Transactions Credit",
    ], // note: debit=+ amount, credit=- amount handled in SQL

    ICICI_Life_Insurance: ["ICICI Prulife Insurance"],
    LIC: ["LIC Insurance"],
    Abacus: ["Abacus Fees"],
    Chess_Fees: ["Chess Fees"],
    Chitfund: ["Chitfund"],
    Personal_Loan: ["Personal Loan"],

    Handcash: ["HandCash From Kandasamy"],
    HandCash_Repayment: ["HandCash Repayment"],

    ATM_Withdraw: ["Cash Withdrawal"],
    EBBills: ["Electricity Bills"],
    PropertyTax: ["House Taxes"],
    Mobile_Recharge: ["Mobile Recharge"],

    Personal_Donations: ["Personal Donations"],
    Pooja_Expenses: ["Pooja Expenses"],
    To_Prakish: ["To Family for Prakish"],
    Gas_Subsidy: ["Gas Subsidy"],
    Demat_Account_Fees: ["Demat Account Fees"],
    Diwali_Gift_To_Family: ["Diwali Gift To Family"],
    To_Amma: ["To Amma"],

    BSNL_Bills: ["BSNL Bills"],
    Cab_Expenses: ["Cab Expenses"],
    Taxfiling_Expenses: ["Taxfiling Expenses"],
    GeniusNexa_Bills: ["GeniusNexa Bills"],
    Credit_Card_Payment: ["Credit Card Payment"],
    Other_Expenses: ["Other Expenses"],
    Billing_Errors: ["Billing Errors"],
  },
];
export default IndCategoryMapping;
